import type { FetchNotificationsParams } from "./notifications.types";

export const notificationsKeys = {
  infiniteList: (entityId: string, params: FetchNotificationsParams) =>
    ["notificationsInfiniteList", entityId, params] as const,

  infiniteListByEntity: (entityId: string) => ["notificationsInfiniteList", entityId] as const,

  unreadCount: (entityId: string) => ["notificationsUnreadCount", entityId] as const,
};
